export default __webpack_public_path__ + "static/media/icn_connected.2b702903.svg";